import React from 'react';
import {
  getItemUrlBySuggestionType,
  getTypeName,
  getIconName
} from '../../helpers/searchBarHelper';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import EffectIcon from '../../icons/EffectIcon';
import BrandIcon from '../../icons/BrandIcon';
import ClassificationIcon from '../../icons/ClassificationIcon';
import SubtypeIcon from '../../icons/SubtypeIcon';
import GeneralIcon from '../../icons/GeneralIcon';
import FlavorIcon from '../../icons/FlavorIcon';
import { DARK_GREY, WHITE } from "../../config/colors";

const Suggestions = ({ types, subTypes, products, brands, classifications, flavors, effects, generals, customerType, isPhone }) => {
  const renderItems = (items, type, isPhone) => {
    return items.map((item, idx) => (
      <Link
        className={`${isPhone ? 'search-result-sm' : 'search-result'}`}
        key={`suggestion-${idx}`}
        to={getItemUrlBySuggestionType(item, type, customerType)}
      >
        {getIcon(getIconName(item, type), isPhone)}
        <div className={`${isPhone ? 'result-title-sm' : 'result-title'}`}>
          {getItemName(item, type, isPhone)}
        </div>
        <div className={`${isPhone ? 'result-kind-sm' : 'result-kind'}`}>
          {getTypeName(item, type).toUpperCase()}
        </div>
      </Link>
    ));
  };
  
  const getIcon = (type) => {
    const isPhone = false;
    let icon;
    switch (type) {
      case 'brand': {
        icon = <BrandIcon color={isPhone ? DARK_GREY : WHITE} />;
        break;
      }
      case 'effect': {
        icon = <EffectIcon color={isPhone ? DARK_GREY : WHITE} />;
        break;
      }
      case 'classification': {
        icon = <ClassificationIcon color={isPhone ? DARK_GREY : WHITE} />;
        break;
      }
      case 'subtype': {
        icon = <SubtypeIcon style={{ width: 'auto', height: 20 }} color={isPhone ? DARK_GREY : WHITE} />;
        break;
      }
      case 'general': {
        icon = <GeneralIcon color={isPhone ? DARK_GREY : WHITE} />;
        break;
      }
      case 'flavor': {
        icon = <FlavorIcon style={{overflow: 'visible'}} viewBox={'0 0 36 25'} color={isPhone ? DARK_GREY : WHITE} />;
        break;
      }
      default:
        icon = <img src={`https://assets.treez.io/icons/${`${isPhone ? type.toLowerCase() : `${type.toLowerCase()}-light`}`}.svg`} />;
        break;
    }
  
    return (
      <span className={`${isPhone ? 'result-type-sm' : 'result-type'}`}>{icon}</span>
    )
  }
  
  const getItemName = (item, type, isPhone) => {
    if (type === 'product') {
      return (
        <div>
          <div className={`${isPhone ? 'result-kind-brand-sm' : 'result-kind-brand'}`}>{item.brand}</div>
          <div className={`${isPhone ? 'result-kind-name-sm' : 'result-kind-name'}`}>{item.name}</div>
        </div>
      )
    }
    if (type === 'subtype') {
      return `${item.name} (${item.type})`
    }
    return item.name;
  }

  return (

    <div>
      {
        !isEmpty(types) && renderItems(types, 'type', isPhone)
      }
      {
        !isEmpty(subTypes) && renderItems(subTypes, 'subtype', isPhone)
      }
      {
        !isEmpty(products) && renderItems(products, 'product', isPhone)
      }
      {
        !isEmpty(brands) && renderItems(brands, 'brand', isPhone)
      }
      {
        !isEmpty(classifications) && renderItems(classifications, 'classification', isPhone)
      }
      {
        !isEmpty(flavors) && renderItems(flavors, 'flavor', isPhone)
      }
      {
        !isEmpty(effects) && renderItems(effects, 'effect', isPhone)
      }
      {
        !isEmpty(generals) && renderItems(generals, 'general', isPhone)
      }
    </div>
  )
}

export default Suggestions


// WEBPACK FOOTER //
// ./src/components/Search/Suggestions.jsx